import { z } from 'zod';

/**
 * A site will be created automatically when a new user session is created (if doesn't already exist).
 */
export const siteSchema = z.object({
  companyCode: z.string(),
  locationCode: z.string(),
  /**
   * Site code maps to the Site.Code used within MySQL on-prem DB.
   */
  siteCode: z.string(),
  /**
   * When site is occupied, this is the session UUID.
   * When the user leaves the site (checks out), this is set to `null`.
   */
  activeSessionUuid: z.uuidv4().nullable().default(null),
  /**
   * Snapshot of the meter switch states from the last switch call — not the live
   * state (the Orto-Mate API only reports switch state in switch responses).
   * Lives on the site rather than the session so status outlives checkout and is
   * still known while the site is vacant. `null` = unknown (never switched, or
   * the last switch attempt failed).
   */
  lastElectricityStatus: z.literal(['ON', 'OFF']).nullable().default(null),
  lastWaterStatus: z.literal(['ON', 'OFF']).nullable().default(null),

  _creationTime: z.number().optional(),
  _id: z.string().optional(),
  updatedAt: z.number().optional(),
});
export type Site = z.output<typeof siteSchema>;

export const siteStrictSchema = siteSchema.safeExtend({
  companyCode: z.string().trim().length(3),
  locationCode: z.string().trim().length(3),
  siteCode: z.string().trim(),
});

export const siteCvxSchema = siteSchema.safeExtend({
  _creationTime: z.number(),
  _id: z.string(),
  updatedAt: z.number(),
});
export type SiteCvx = z.output<typeof siteCvxSchema>;
